import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { media } from '../styles/Mixin';



const getDeskSize = size => {
    let number;
    if (size === "sm") {
        number = 30
    } else if (size === "s_md") {
        number = 40
    } else if (size === "m_md") {
        number = 50
    } else if (size === "l_md") {
        number = 100
    } else if (size === "lg") {
        number = 150
    }
    return `
        width:${number}px;
        height:${number}px;
    `;
}
const getMobileSize = size => {
    let number;
    if (size === "sm") {
        number = 10
    } else if (size === "s_md") {
        number = 20
    } else if (size === "m_md") {
        number = 30
    } else if (size === "l_md") {
        number = 60
    } else if (size === "lg") {
        number = 90
    }
    return `
        width:${number}px;
        height:${number}px;
    `;
}


const Container = styled.div`
    ${media.deskTop`${props => getDeskSize(props.size)}`}
    ${media.mobile`${props => getMobileSize(props.size)}`}
    background-image:url(${props => props.url});
    background-size: cover;
    border-radius:50%;
`;


const Avatar = ({ size = "sm", url, className, onClick }) => {
    
    return (
        <Container size={size} url={url} className={className} onClick={onClick} />
    )
}

Avatar.propTypes = {
    size: PropTypes.oneOf(['sm', 's_md', 'm_md', 'l_md', 'lg']),
    url: PropTypes.string.isRequired
}


export default Avatar;